// extracted by mini-css-extract-plugin
export default {"container":"RegistrationForm_container__cWBsk","passwordInput":"RegistrationForm_passwordInput__VZrka","dropdownContent":"RegistrationForm_dropdownContent__8MNFH"};